import { render } from "./Photography.vue?vue&type=template&id=19dd2cf1&scoped=true"
import script from "./Photography.vue?vue&type=script&lang=js"
export * from "./Photography.vue?vue&type=script&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=19dd2cf1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19dd2cf1"

export default script